import React, { useState, useEffect } from "react";
import "./ChooseFile.css";

function ChooseFile({ accept, defaultValueImage, currentFile, _setFile, loadAnim, colorBorder }) {
    const [file, setFile] = useState(defaultValueImage ? defaultValueImage : "");
    const [preview, setPreview] = useState();

    useEffect(() => {
        if (currentFile) {
            setFile(currentFile.name);
            setPreview(currentFile);
        }
    }, [currentFile]);

    if (loadAnim == true && !isImage()) {
        loadAnimationFile(true);
    } else if (loadAnim == "finish") {
        //
        loadAnimationFile(false);
    }

    function changeValue(e, defaultValue = null) {
        let fileSetUp = e == null ? defaultValue : e.target.value.split("\\").pop();
        if (isImage()) {
            // or others files images
            if (defaultValue == null) {
                document.getElementById("border_anim").classList.add("draw");
            }
            setPreview(e == null ? defaultValue : e.target.files[0]);
        }
        if (_setFile != undefined) {
            _setFile(e == null ? defaultValue : e.target.files[0]);
        }
    }
    function isImage() {
        return accept.includes(".png");
    }
    function loadAnimationFile(_bool) {
        document.getElementById("loader_anim").style.display = _bool ? "block" : "none";
        if (loadAnim == "finish") {
            document.getElementById("svg_checkfile").style.display = "block";
        }
    }
    return (
        <div id="border_anim" className={"file-drop-area " + (colorBorder ? "default " : " ")}>
            <input id="input_file" name="image" className="file-input" type="file" accept={accept} onChange={(e) => changeValue(e)}></input>
            <span id="choose_file" className="fake-btn" style={{ display: defaultValueImage == null && preview == null ? "block" : "none" }}>
                Choose file
            </span>
            <span id="preview_container" style={{ display: isImage() ? (preview || defaultValueImage ? "block" : "none") : "none" }}>
                <img id="preview_image" src={preview ? URL.createObjectURL(preview) : defaultValueImage}></img>
            </span>

            <span className="file-msg">  {file != "" && defaultValueImage == null ? file + " is ready for import" : defaultValueImage ? "    drag and drop your new logo here" : `or drag and drop ${accept} file here`} </span>

            <svg id="svg_checkfile" viewBox="0 0 52 52" className="checkmark" style={{ display: !preview ? "none" : "block" }}>
                <circle className="checkmark__circle" cy="26" cx="26" r="25" fill="none"></circle>
                <path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"></path>
            </svg>
            <div id="loader_anim" className="loader" style={{ display: "none" }}>
                <div className="load-one"></div>
                <div className="load-two"></div>
                <div className="load-three"></div>
            </div>
        </div>
    );
}

export default ChooseFile;
